/* eslint-disable no-unused-vars */

export enum AppPaths {
  home = '/',
  connect = '/connect',
  tasks = '/tasks',
  taskList = '/tasks/list-view',
}
